
import { Link } from "react-router-dom";
import React from "react";

interface AuthFooterLinksProps {
  mode: "login" | "signup";
}

const AuthFooterLinks: React.FC<AuthFooterLinksProps> = ({ mode }) => {
  if (mode === "login") {
    return (
      <div className="text-center space-y-2">
        <div>
          <Link to="/auth/forgot-password" className="text-sm text-primary hover:underline">
            Forgot your password?
          </Link>
        </div>
        <div className="text-sm text-black">
          Don't have an account?{" "}
          <Link to="/auth/signup" className="text-primary hover:underline">
            Sign up
          </Link>
        </div>
      </div>
    );
  }
  return (
    <div className="text-center space-y-2">
      <div className="text-sm text-black">
        Already have an account?{" "}
        <Link to="/auth/login" className="text-primary hover:underline">
          Sign in
        </Link>
      </div>
    </div>
  );
};

export default AuthFooterLinks;
